import script from "./Org.vue?vue&type=script&setup=true&lang=ts"
export * from "./Org.vue?vue&type=script&setup=true&lang=ts"

import "./Org.vue?vue&type=style&index=0&id=743184c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-743184c5"]])

export default __exports__